Monitoring.Models.SocialContents ||= {}

class Monitoring.Models.SocialContents.InstagramCommentContentFactory

  create: (socialContent, allTags) ->
    return new Monitoring.Models.SocialContents.InstagramCommentContent(socialContent).set({ possibleTags: allTags })

  canHandle: (socialContent) ->
    return socialContent.group_type == 'instagramapi' and socialContent.data and socialContent.data.type == 'instagramComment'
